<template>
  <div>
    <!--<ejs-textbox></ejs-textbox>-->
    <div class="h100vh-500">
    <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column field="mcsid" :visible="false"></e-column>
        <e-column field='userNum' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userNum")' width='150' textAlign='Center'></e-column>
        <e-column field='userAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='150' textAlign='Center'></e-column>
        <e-column field='participantType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
        <e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='registerStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>
        <e-column field='stunStatus' clipMode='EllipsisWithTooltip' :valueAccessor='stunStatusFormatter' :headerText='$t("MCS.stunKillStatus")' width='150' textAlign='Center'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getGridData(info)' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'UserTableLayer',
  mixins: [commonJS],
  data() {
    return {
      data: {},
      info: '',
      userNumSearch: '',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
    };
  },
  methods: {
    getGridData(ne = null, participantType = 0) {
      const $this = this;
      let vo;
      $this.info = ne;
      console.log('infoinfo', $this.info)
      if (ne !== null && participantType === 0) {
        vo = {
          flag: 0,
          participantType: 0
        };
      } else {
        vo = {
          flag: 2,
          userNum: $this.userNumSearch,
          participantType: participantType
        };
      }
      // $this.info.msgid = $this.msg.qryUsers;
      // const page = {
      //   pageNo: 1,
      //   pageSize: this.page.pageSize
      // };
      const params = {
        info: $this.info,
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      console.log('params', params);
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data;
        $this.data = res.resultVal.result === 0 ? [] : res.resultVal.result;
        $this.page.totalCount = res.resultVal.countrsp;
      });
    },

    getClickData() {
      return this.$refs.grid.getSelectedRecords()[0];
    }
  },
};
</script>

<style scoped>

</style>
